'use strict';

angular.module('shiftTraderApp')
  .directive('employeeProfileTopBar', ['TimeService', 'WorkPeriods', function (TimeService, WorkPeriods) {
    return {
      templateUrl: 'views/employeeProfile/employeeProfileTopBar.html',
      scope: {
        user: '=employeeProfileTopBar'
      },
      link: function(scope, elem, attrs, controller) {
        var today = TimeService.getNowInStoreTime()
        scope.state = {
          activeState: null,
          phoneNumber: {
            raw: scope.user.$primary_phone_number(),
            formatted: scope.user.$primary_formatted_phone_number()
          }
        }

        function calcNextWorkPeriod (workPeriods) {
          if (lodash.isNull(workPeriods) || lodash.isUndefined(workPeriods) || lodash.isEmpty(workPeriods)) {
            return null
          }

          var filter = lodash.sortBy(lodash.filter(workPeriods, function (wp) {
            return wp.start_time >= today
          }), function (wp) {
            return wp.start_time.unix()
          })

          return filter[0]
        }

        var startDateForShiftQuery = moment(today).subtract(1, 'day').toISOString()
        WorkPeriods.getAll({
          user_id: scope.user.id,
          start_time: startDateForShiftQuery
        }).then(function (data) {
          scope.nextWorkPeriod = calcNextWorkPeriod(
            lodash.filter(data, function (wp) {
              return wp.$isPublished()
            })
          )
        })

        scope.$watch('user.memberships[0].active', function (newVal, oldVal) {
          if (newVal !== oldVal) {
            computeActiveState()
          }
        })

        function computeActiveState() {
          if (scope.user.memberships[0].active && scope.user.activated_at) {
            scope.state.activeState = 'active'
          } else if (!scope.user.memberships[0].active) {
            scope.state.activeState = 'inactive'
          } else {
            scope.state.activeState = 'pending'
          }
        }

        computeActiveState()
      }
    }
  }])
